import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton, DropdownButton } from "react-bootstrap";
import { useState, useEffect, useReducer, useRef} from "react";
import ListUserTable from "Containers/Private/User/List/ListUserTable";
import {useLocation } from 'react-router-dom';
import { STATUSES } from "Utils/constants";
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {Link, useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { NavLink } from "react-router-dom";
import {Helmet} from "react-helmet";
import axios from "axios";
//import { Api, TableauViz } from '@tableau/embedding-api-react';
import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import TableauView from "./TableauView";
import { openInNewTab, openInNewTabWithState } from "Utils/utilityFunctions";




const TableauReports = () => {
   
    const navigate = useNavigate();
    const t = window.tableau;
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);

    //const [isLoading, setIsLoading] = useState(true)

    var dispatch = useDispatch();


    const loginState = store.getState().loginInfo;

    const [isLoading, setIsLoading] = useState(true);
    
    var categories = {};
    var timePeriods = {};
    var reports = {};

    var viz = null;
    //var scriptUrl = null;
    //var viewUrl = null;

    //const [viz, setViz] = useState(null);
    const [viewUrl, setViewUrl] = useState(null);
    const [viewMap, setViewMap] = useState(null);
    const [scriptUrl, setScriptUrl] = useState(null);
    const [ticket, setTicket] = useState(null);
    const [name, setName] = useState(null);
    const [defaultView, setDefaultView] = useState(null);
 const [reportId, setReportId] = useState(null);
    const [cats, setCats] = useState({});
    const [tps, setTps] = useState({});
    const [rps, setRps] = useState({});

    const [showTermsPopup, setShowTermsPopup] = useState(true);

  
    const ref = useRef(0);

    useEffect(() => {
       loadFormData();

    }, []); // Empty dependency array ensures the effect runs only once

   
    
        const getFormData = async () => {
    
            var url = '/api/interactiveReports/tableauReport';
            const loginState = store.getState().loginInfo;
            
    
            return http.post(url, null, {
                headers: {
                    "Authorization": "Bearer " + loginState.token
                    //"Referrer-Policy": "strict-origin-when-cross-origin"
                }
            });
        }

        const getReportView = async (reportId) => {
    
            var url = '/api/interactiveReports/viewTaleauReport';
            const loginState = store.getState().loginInfo;
            var data = {
                reportId: reportId
            }
    
            return http.post(url, data, {
                headers: {
                    "Authorization": "Bearer " + loginState.token
                    //"Referrer-Policy": "strict-origin-when-cross-origin"
                }
            });
        }

     
        const loadFormData = async () => {
            
            var reports = {};
            setIsLoading(true);
            return getFormData().then((res) => {
                //console.log("getFormData ", res);

                if (res.status != 1) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.DATA_ERROR.title,
                            msg: res.globalErrorMessageList[0],
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {
                    //console.log(res);
                    var d = res.data;
                    
                    
                    for(var x = 0 ; x < d.length ; x++){
                        for(var y = 0 ; y < d[x].length ; y++){

                            var category = {};
                            var timePeriod = {};

                            //console.log(d[x]);
                            //console.log(d[x][y]);
                            var data = d[x][y];
                            //console.log(data);

                            var catId = data.categoryId;
                            var catDesc = data.categoryDesc;
                            var timePeriodId = data.timePeriodId;
                            var timePeriodDesc = data.timePeriodDesc;
                            
                            if(!Object.keys(cats).includes(catId)){
                                cats[catId] = catDesc;
                            }

                            //console.log("Catid: " + catId + " - TimePeriodId: " + timePeriodId);

                            if(tps.hasOwnProperty(catId)){
                                //console.log(tps[catId]);
                                if(!tps[catId].hasOwnProperty(timePeriodId)){
                                    tps[catId][timePeriodId] = timePeriodDesc;
                                }
                            }
                            else{
                                tps[catId] = {};
                                tps[catId][timePeriodId] = timePeriodDesc;
                            }
                            
                            //console.log(rps);
                            if(rps.hasOwnProperty(catId)){
                                if(rps[catId].hasOwnProperty(timePeriodId)){
                                    rps[catId][timePeriodId].push(data);
                                }
                                else{
                                    rps[catId][timePeriodId] = [];
                                    (rps[catId][timePeriodId]).push(data);
                                }
                            }
                            else{
                                rps[catId] = {};
                                rps[catId][timePeriodId] = [];
                                (rps[catId][timePeriodId]).push(data);
                            }

                            //console.log(cats);
                            //console.log(tps);
                             //console.log(rps);

                        }
                    }   
                }

                // //console.log(categories);
                // //console.log(timePeriods);
                setIsLoading(false);
                return res;
            }).catch((error) => {
                //console.log("Error caught while loading data: " + error);
    
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
            });
            
        };

        const vizEl = () =>{
            
            //console.log(t);

            var vizDiv = ref.current;//document.getElementById("tableauViz");

            
            var options = {
                hideTabs: false,
                onFirstInteractive: function() {
                    // Code to run after the viz is fully loaded
                    var workbook = viz.getWorkbook();
                    //console.log(workbook);
                    //console.log("Viz is interactive!");
                }
                
            };
            if (viz != null) { // If a viz object exists, delete it.
                viz.dispose();
            }

            //console.log(ref.current);
            //vizURL = vizURL + "?iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";

            viz = new t.Viz(vizDiv, (viewMap)[defaultView], options);
            var work = new t.Workbook();
            //console.log(work);
            viz.addEventListener("tabSwitch", (e) => {
                //console.log(e);
                //console.log("switch");
                handleTabChange();
            })
            //console.log(viz.event);
            //setFrameSize
            //handleVizInteractiveEvent
            //handleTabSwitchEvent
            //handleInitialVizSize
            //addWindowResizeHandler
            //console.log(t.Viz);
            //console.log(viz.getUrl());
            
            // viz.raiseTabSwitch()
            

        }

        const loadReportView = async (reportId, e) => {
            //console.log(e);
            //console.log(reportId);
            setReportId(reportId);
            /*//console.log(e);
            setShowTermsPopup(true);
            var reports = {};
            
            return getReportView(reportId).then((res) => {
                //console.log("getFormData ", res);
                if (res.status != 1) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.DATA_ERROR.title,
                            msg: res.globalErrorMessageList[0],
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {
                     //console.log(reportRef.current);
                    setScriptUrl(res.data.jsString);
                    setViewMap(res.data.viewMap);
                    setViewUrl((res.data.viewMap)[res.data.defaultView]);
                    setTicket(res.data.creds);
                    setDefaultView(res.data.defaultView);
            //var vizDiv = reportRef.current[0],
            //    options = {
            //        hideTabs: false
             //   };

            
                    
                   
                }
                return res;
            }).catch((error) => {
                //console.log("Error caught while loading data: " + error);
    
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
            });*/
            
        };

         const hideTermsPopup = () => {
            setShowTermsPopup(false);
       
        }

    var popupButtons = [
        
        {
            text: "Close",
            action: hideTermsPopup,
            variant: "outline",
            //disabled: false
        }
    ]

 
    const handleTabChange = (e) => {
        //console.log(e.target.innerText);
        //console.log(viewMap['DSSR Production Summary']);
        setViewUrl(viewMap['DSSR Production Summary']);
        /*ref.current.getWorkbook().then(workbook => {
            workbook.activateSheetAsync("Sheet Name"); // Replace "Sheet Name" with the actual name of the sheet
        });*/
    }
const ExternalAd = () => {
  const advRef = useRef(null)

  

  return <div id="adv" ref={advRef}></div>
}
    return (
        
        
            isLoading==false 
         ?
        <Row>
            
            <Row >
                    <Col xl={10} lg={11} md={12} sm={12}>
                        
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold" >Interactive Reports</h1>
                                    <p><b>Clinical Dashboard Disclaimer:</b> The Clinical Dashboards can reliably display and compare patterns and trends related to the volume of CFER-H reports submitted to the PSOPPC and the data elements therein. However, to the extent the data and scores reflected in the Clinical Dashboards are derived from voluntary reporting systems, the Clinical Dashboards are unlikely to be reliable for purposes of measuring, comparing or trending actual rates of events.</p>
                                </Row>
                                <Row>
                                    <Form>
                                        <Row>
                                            {reportId!=null ?<TableauView reportId={reportId}></TableauView>
                                            :null
                                        }
                                            
                                           {/*} <DynamicFormPopup
                                                showPopup = {showTermsPopup}
                                                handleClose = {hideTermsPopup}
                                                buttons = {popupButtons}
                                                title = {"PSOPPC Help Center Term of Use"}
                                                type= {"blank"}
                                                variant={"blank"}
                                            >
                                                {viewMap!=null ?
                                                    <div className="ms-4 me-4 mt-2">
                                                        <Dropdown>
                                                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                Dropdown Button
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                                                                <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                                                                <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        {/*ticket != null && scriptUrl!=null?*/}
                                                        {/*<>
                                                            <TableauViz src={viewUrl} token={ticket}></TableauViz>*/}
                                                           {/*<tableau-viz ref={reportRef} id='tableau-viz' src={viewUrl} width='1869' height='915' toolbar='bottom' ></tableau-viz>
                                                            <tableau-viz 
                                                                id='tableau-viz' src={viewUrl} token={ticket}  toolbar='bottom' height={'800'} width={"800"} hide-tabs={false} hide-edit-button={true} disable-url-actions={true} hide-custom-views={true}>
                                                            </tableau-viz>
                                                          
                                                       
                                                            <div ref={ref} shouldComponentUpdate id='tableauViz'  width='1869' height='915'></div>

                                                        </>
                                                        :null

                                                    </div> 
                                                : null 
                                        }
                                            </DynamicFormPopup>*/}
                                       
                                            
                                            <Col className="reports-list">
                                                {
                                                    Object.entries(cats).length > 0 ?
                                                        Object.entries(cats).map(([ck,cv])=> {
                                                            //console.log("key: " + ck + "Value: " + cv);
                                                            //return key;
                                                            if(tps[ck]!=null){
                                                                //console.log(cv);
                                                                return (
                                                                    <div className="d-flex flex-column gap-3">
                                                                        <h2>{cv}</h2>

                                                                        {
                                                                            Object.entries(tps[ck]).map(([tk,tv])=> {
                                                                                //console.log("tk: " + tk + "tv: " + tv)
                                                                                return (
                                                                                    <>
                                                                                        {
                                                                                            tv != null 
                                                                                            ?   <h3 >{tv}</h3>
                                                                                            :   null
                                                                                        }
                                                                                        {/*<a href="#" class="external-link" onClick={(e)=>loadReportView(rv.reportId,e)} >{rv.reportName}</a>);*/}
                                                                                        {
                                                                                            (rps[ck][tk]).map((rv)=> {
                                                                                                //console.log("rv: " + JSON.stringify(rv))
                                                                                                return (<a as={Button} tabIndex="0" class="external-link " 
                                                                                                    onKeyDown={(e)=>{
                                                                                                        //console.log(e);
                                                                                                        if (e.key == "Enter") { 
                                                                                                            openInNewTabWithState("/analytics/dashboard/view", JSON.stringify({reportId: rv.reportId}))
                                                                                                        }
                                                                                                    }}
                                                                                                    onClick={(e)=>
                                                                                                        openInNewTabWithState("/analytics/dashboard/view",
                                                                                                            JSON.stringify({reportId: rv.reportId})
                                                                                                        )
                                                                                                     
                                                                                                }>{rv.reportName}</a>)
                                                                                                /*(<Button
                                                                                                    class="external-link"
                                                                                                    value={rv.reportId}
                                                                                                    onClick={(e)=>{ setReportId(e.target.value);
                                                                                                        //console.log(this); //console.log(e); loadReportView(e.target.value);
                                                                                                    }} >
                                                                                                    {rv.reportName}</Button>
                                                                                                    
                                                                                                    
                                                                                                )*/
                                                                                            })
                                                                                        }
                                                                                    </>
                                                                                )
                                                                                    
                                                                            })
                                                                        }
                                                                    </div>
                                                                ) 
                                                            }
                                                            else{
                                                                return null;
                                                            }
                                                        })
                                                                        
                                                    :null
                                                   
                                                }
                                                
                                            </Col>
                                        </Row>
                                    </Form>
                                </Row>
                                    
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            
            </Row>
        : null  
        
    
    )
}

export default TableauReports;